import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Flex } from 'antd';
import { useAppSelector } from 'app/hooks';
import { Content } from 'antd/es/layout/layout';
import Footer from 'components/Footer/Footer';
import layoutStyles from 'components/Layout/Layout.module.scss';
import { selectUserSignInStatus } from 'services/session/sessionSelectors';

function UnAuthRoute() {
  const isLogin = useAppSelector(selectUserSignInStatus);
  const location = useLocation();

  if (isLogin) {
    return (
      <Navigate
        to={{ pathname: '/dashboard', search: location.search }}
        replace
      />
    );
  }

  return (
    <Flex vertical className={`${layoutStyles.contentWrapper} alignStretch`}>
      <Content className={`${layoutStyles.content} verticalFlex alignStretch`}>
        <Flex vertical className={layoutStyles.pageSectionWrapper}>
          <Outlet />
        </Flex>
      </Content>
      <Footer />
    </Flex>
  );
}

export default UnAuthRoute;
